import React from 'react';
import { Image, StyleSheet } from 'react-native';

const FLAG_RESOURCES = {
  ES: require('../../../../resources/ES.png'),
  US: require('../../../../resources/US.png'),
  PH: require('../../../../resources/PH.png'),
};

export default (FlagIcon = props => {
  const { languageTag } = props;
  if (!languageTag) return null;

  const country = languageTag.split('-')[1];
  if (!country || !FLAG_RESOURCES[country]) return null;

  return <Image style={[styles.flagIcon, props.containerStyle]} source={FLAG_RESOURCES[country]} />;
});

const styles = StyleSheet.create({
  flagIcon: {
    width: 21,
    height: 15,
  },
});
